import root from "window-or-global";

export const getSystemName = () => root.clientConfig?.systemName ?? "atgse";

/**
 * @deprecated Tillsammans are now under decomissioning and this should not be used anymore.
 * @returns true if Tillsammans standalone app
 */
export const isTillsammans = () => getSystemName() === "tillsammans";

/**
 * This is only for the native part of the app. The app got several different webviews, e.g. sport,
 * and then other functions needs to be used.
 */
export const isApp =
    "HermesInternal" in root && typeof root.HermesInternal !== "undefined";

/**
 * This is only for the sport webviews (sportsbook and odds receipts, NOT big 9) part of the app.
 */
export const isSportApp = getSystemName() === "ATG-Sports-App";

/**
 * This is only for the casino webview (the actual running game, starburst etc). The other part of the casino is native.
 */
export const isCasinoApp = getSystemName() === "ATG-Casino-App";

/**
 * This is only for the horse webview (Kambi betslip).
 */
export const isHorseApp = getSystemName() === "ATG-Horse-App";

/**
 * This is only for the app webviews we have on "Mitt konto" etc but not for sportsbook nor casino webviews.
 *
 * Note: webview URL:s might start with a language code in the URL, e.g. "/fi/app/v2/..." vs "/app/v2/...", both of these
 * are considered app webviews.
 */
export const isAppWebview = /^(\/[a-z]+)?\/app\/v[0-9]+\//.test(root.location?.pathname);

export const isNotAppAndTillsammans = getSystemName() === "atgse" && !isAppWebview;

export const isWeb = !isApp;

type TrackingSystem = "NativeApp" | "AppWebView" | "Web";

export const currentTrackingSystem = (): TrackingSystem => {
    if (isApp) {
        return "NativeApp";
    }
    if (isSportApp || isCasinoApp) {
        return "AppWebView";
    }

    return "Web";
};
